import script from "./FieldSetTag.vue?vue&type=script&setup=true&lang=ts"
export * from "./FieldSetTag.vue?vue&type=script&setup=true&lang=ts"

import "./FieldSetTag.vue?vue&type=style&index=0&id=333a25b6&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-333a25b6"]])

export default __exports__